<template>
  <div class="page">
    <el-row class="margin-bottom">
      <el-col :span="12">
        <el-input
          v-model="filters[1].value"
          placeholder="Zoek op titel.."
        ></el-input>
      </el-col>
      <el-col
        :span="12"
        class="text-right"
      >
        <el-checkbox-group v-model="filters[0].value">
          <el-checkbox label="true">Archief</el-checkbox>
        </el-checkbox-group>
      </el-col>
    </el-row>

    <data-tables
      v-loading="loading"
      :data="promotions"
      :pagination-props="{ pageSizes: [20, 40, 60] }"
      :filters="filters"
    >
      <el-table-column
        v-for="title in titles"
        :prop="title.prop"
        :label="title.label"
        :key="title.label"
        sortable="custom"
        :width="title.width"
      >
      </el-table-column>

      <el-table-column
        label="Preview"
        min-width="170px"
        width="200"
      >
        <template slot-scope="scope">
          <a
            :href="`https://www.samsung.com/nl/promo/promo/?id=${scope.row.id}`"
            target="_blank"
          >
            <el-button size="mini">STAGING</el-button>
          </a>
          <a
            :href="`https://qaweb.samsung.com/nl/promo/promo/?id=${scope.row.id}`"
            target="_blank"
          >
            <el-button size="mini">LIVE</el-button>
          </a>
        </template>
      </el-table-column>

      <el-table-column
        label="Actions"
        min-width="100px"
        width="130"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.staticUrl !== false">
            <el-tag size="medium">STATIC URL</el-tag>
          </div>
          <div v-if="scope.row.created === true">
            <el-button
              size="mini"
              @click="handleEdit(scope.$index, scope.row)"
              icon="el-icon-edit"
            ></el-button>
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.$index, scope.row)"
              icon="el-icon-delete"
            ></el-button>
          </div>
          <div
            v-if="scope.row.created === false"
            v-show="scope.row.staticUrl === false"
          >
            <el-button
              size="mini"
              @click="handleEdit(scope.$index, scope.row)"
              icon="el-icon-circle-plus"
            ></el-button>
          </div>
        </template>
      </el-table-column>
    </data-tables>
  </div>

</template>

<script>
import store from "../store";
import axios from "axios";
import { promotionsCollection } from "../firebase-config.js";

export default {
  data: function() {
    return {
      promotions: [],
      language: "nl",
      loading: true,
      titles: [
        {
          prop: "configId",
          label: "Config ID",
          width: "100"
        },
        {
          prop: "id",
          label: "ID",
          width: "130"
        },
        {
          prop: "title",
          label: "Titel"
        },
        {
          prop: "period",
          label: "Periode",
          width: "170"
        }
      ],
      filters: [
        {
          prop: "promotionEnded",
          value: false
        },
        {
          value: "",
          prop: "title"
        },
        {
          value: "",
          prop: "id"
        },
        {
          value: "",
          prop: "configId"
        }
      ],
      formOptions: {
        inline: true,
        submitBtnText: "Zoeken",
        forms: [
          { prop: "title", label: "Titel" },
          { prop: "id", label: "ID" },
          { prop: "configId", label: "Config ID" },
          {
            prop: "promotionEnded",
            label: "Periode",
            itemType: "select",
            options: [
              { value: "", label: "All" },
              { value: false, label: "Actueel" },
              { value: true, label: "Archief" }
            ]
          }
        ]
      },
      columns: [
        { prop: "configId", label: "Config Id", width: "80" },
        { prop: "id", label: "id" },
        { prop: "title", label: "Titel", width: "auto" },
        { prop: "period", label: "Periode", width: "200", filter: false },
        { prop: "id", label: "Edit", slotName: "rowEdit" }
      ],
      now: ""
    };
  },
  watch: {
    $lang() {
      this.getData();
    }
  },
  mounted() {
    this.getData();
    // var jobskill_query = promotionsCollection.where(
    //   "promotionId",
    //   "==",
    //   "FX5YQB344AD84"
    // );
    // jobskill_query.get().then(function(querySnapshot) {
    //   querySnapshot.forEach(function(doc) {
    //     doc.ref.delete();
    //   });
    // });
    // console.log(jobskill_query, "jobskill_query");
  },
  methods: {
    getData() {
      console.log("getdata");
      this.promotions = [];
      axios
        .get(`https://sebnapi.nl/promo/${this.$lang}/cached/promotions.json`)
        .then(data => {
          console.log("mounted");

          data.data.forEach(item => {
            const conditionalDate = item.item.participationEndDate.split("-");
            let promotionEnded = false;

            const period = `${item.item.startDate} / ${item.item.endDate}`;
            this.loading = false;

            const date = new Date();
            const day = (date.getDate() < 10 ? "0" : "") + date.getDate();
            const month =
              (date.getMonth() + 1 < 10 ? "0" : "") + (date.getMonth() + 1);
            const year = date.getFullYear();
            this.now = `${year}${month}${day}`;

            const endDate = item.item.endDate.split("-");
            const conditionalEndDate =
              endDate[2] +
              ("0" + endDate[1]).slice(-2) +
              ("0" + endDate[0]).slice(-2);

            if (this.now > conditionalEndDate) {
              promotionEnded = true;
            } else {
              promotionEnded = false;
            }
            if (item.item.isActive) {
              console.log("item", item);
              promotionsCollection.onSnapshot(promotionsRef => {
                promotionsCollection
                  .where("promotionId", "==", item.item.id)
                  .get()
                  .then(querySnapshot => {
                    this.loading = false;
                    if (querySnapshot.docs.length === 1) {
                      querySnapshot.forEach(doc => {
                        this.promotions.push({
                          id: item.item.id,
                          configId: this.getConfigValue(
                            item.item.ConfigValues,
                            "SortCarousel"
                          ),
                          title: item.item.title,
                          category: item.item.category,
                          image: item.item.image,
                          isActive: item.item.isActive,
                          promotionMicrositeTitle:
                            item.item.promotionMicrositeTitle,
                          promotionMicrositeDescription:
                            item.item.PromotionMicrositeDescription,
                          IsForSamsungMembers: item.item.isForSamsungMembers,
                          IsPreview: item.item.isPreview,
                          staticUrl: this.getConfigValue(
                            item.item.ConfigValues,
                            "StaticUrl"
                          ),
                          startDate: item.item.startDate,
                          period: period,
                          endDate: item.item.endDate,
                          promotionEnded: promotionEnded,
                          participationStartDate:
                            item.item.participationStartDate,
                          participationEndDate: item.item.participationEndDate,
                          conditionalDate:
                            conditionalDate[2] +
                            conditionalDate[1] +
                            conditionalDate[0],
                          created: true
                        });
                      });
                    } else {
                      this.promotions.push({
                        id: item.item.id,
                        configId: this.getConfigValue(
                          item.item.ConfigValues,
                          "SortCarousel"
                        ),
                        title: item.item.title,
                        category: item.item.category,
                        image: item.item.image,
                        isActive: item.item.isActive,
                        promotionMicrositeTitle:
                          item.item.promotionMicrositeTitle,
                        promotionMicrositeDescription:
                          item.item.PromotionMicrositeDescription,
                        IsForSamsungMembers: item.item.isForSamsungMembers,
                        IsPreview: item.item.isPreview,
                        staticUrl: this.getConfigValue(
                          item.item.ConfigValues,
                          "StaticUrl"
                        ),
                        startDate: item.item.startDate,
                        period: period,
                        endDate: item.item.endDate,
                        promotionEnded: promotionEnded,
                        participationStartDate:
                          item.item.participationStartDate,
                        participationEndDate: item.item.participationEndDate,
                        conditionalDate:
                          conditionalDate[2] +
                          conditionalDate[1] +
                          conditionalDate[0],
                        created: false
                      });
                    }
                  });
              });
            }
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
    handleEdit(index, row) {
      this.$router.push(`/update/${row.id}`);
    },
    handleDelete(index, row) {
      this.$confirm(
        "Weet je zeker dat je dit item wilt verwijderen?",
        "Waarschuwing",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning"
        }
      )
        .then(() => {
          // recieve items in document
          promotionsCollection
            .where("promotionId", "==", row.id)
            .get()
            .then(querySnapshot => {
              querySnapshot.forEach(doc => {
                promotionsCollection
                  .doc(doc.id)
                  .collection("models")
                  .get()
                  .then(querySnapshot => {
                    querySnapshot.forEach(model => {
                      promotionsCollection
                        .doc(doc.id)
                        .collection("models")
                        .doc(model.id)
                        .delete()
                        .then(doc => {
                          console.log(
                            "Sub collection model successfully deleted!"
                          );
                        })
                        .catch(function(error) {
                          console.log("error");
                        });
                    });
                  });

                promotionsCollection
                  .doc(doc.id)
                  .collection("codes")
                  .get()
                  .then(querySnapshot => {
                    querySnapshot.forEach(model => {
                      promotionsCollection
                        .doc(doc.id)
                        .collection("codes")
                        .doc(model.id)
                        .delete()
                        .then(doc => {
                          console.log(
                            "Sub collection codes successfully deleted!"
                          );
                          this.getData();
                        })
                        .catch(function(error) {
                          console.log("error");
                        });
                    });
                  });

                promotionsCollection
                  .doc(doc.id)
                  .delete()
                  .then(doc => {
                    console.log("Document successfully deleted!");
                    this.$message({
                      type: "success",
                      message: "Het item is succesvol verwijderd!"
                    });
                    this.getData();
                  })
                  .catch(function(error) {
                    console.error("Error removing document: ", error);
                    this.$message({
                      type: "error",
                      message: "Er is iets mis gegaan. Probeer het nogmaals."
                    });
                  });
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Het verwijderen is geannuleerd."
          });
        });
    },
    filterTag(value, row) {
      //return row.availableDevices === value;
    },
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
    getConfigValue: function(data, field) {
      const value = data.filter(function(config) {
        return config.ConfigValueName === field;
      });

      if (typeof value !== "undefined" && value.length > 0) {
        return value[0].ConfigValueValue;
      } else {
        return false;
      }
    }
  },
  computed: {
    $lang: function() {
      return this.$store.state.$lang;
    }
  }
};
</script>

<style>
.el-table .disabled-row {
  background: oldlace;
}
.el-table .always-row {
  background: blue;
}
.cell {
  text-align: left;
}

.text-right {
  font-weight: bold;
}

.margin-bottom {
  margin-bottom: 20px;
}
</style>


// WEBPACK FOOTER //
// Home.vue?7ee12524